import React from "react";
import { useLang } from "@/contexts/LanguageContext";
import { LANGS } from "@/i18n/routeMap";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
} from "@/components/ui/dropdown-menu";
import { ChevronDown } from "lucide-react";

const FLAGS = {
  en: "https://flagcdn.com/w40/gb.png",
  es: "https://flagcdn.com/w40/es.png",
  ru: "https://flagcdn.com/w40/ru.png",
  fr: "https://flagcdn.com/w40/fr.png",
  de: "https://flagcdn.com/w40/de.png",
  it: "https://flagcdn.com/w40/it.png",
  nl: "https://flagcdn.com/w40/nl.png",
  pl: "https://flagcdn.com/w40/pl.png",
};
const LABELS = { en: "EN", es: "ES", ru: "RU", fr: "FR", de: "DE", it: "IT", nl: "NL", pl: "PL" };
const FULL = {
  en: "English", es: "Español", ru: "Русский",
  fr: "Français", de: "Deutsch", it: "Italiano",
  nl: "Nederlands", pl: "Polski",
};

export default function LanguageSwitcher() {
  const { lang, setLang } = useLang();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="language-switcher"
        className="flex items-center gap-2 border border-[#2A2A2A] hover:border-[#C9A55A] transition-colors px-2.5 h-10 text-[#F5F1EB]">
        <img src={FLAGS[lang]} alt={LABELS[lang]} className="w-5 h-3.5 object-cover" />
        <span className="text-xs font-semibold tracking-[0.18em]">{LABELS[lang]}</span>
        <ChevronDown size={12} className="text-[#C9A55A]" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-[#0C0C0C] border-[#2A2A2A] text-[#F5F1EB] min-w-[160px] rounded-none">
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l}
            data-testid={`lang-option-${l}`}
            onClick={() => setLang(l)}
            className={`cursor-pointer flex items-center gap-3 rounded-none focus:bg-[#2A2A2A] focus:text-[#C9A55A] ${l === lang ? "text-[#C9A55A]" : ""}`}>
            <img src={FLAGS[l]} alt={LABELS[l]} className="w-5 h-3.5 object-cover" />
            <span className="text-xs font-semibold tracking-[0.16em]">{LABELS[l]}</span>
            <span className="ml-auto text-[10px] text-[#8A8A8A]">{FULL[l]}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
